function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Firebase = function () {
    function Firebase() {
        _classCallCheck(this, Firebase);

        this.firebaseApp = undefined;
    }

    Firebase.prototype.initFirebase = function initFirebase(firebaseApp) {
        this.firebaseApp = firebaseApp;
    };

    return Firebase;
}();

export var firebase = new Firebase();


//////////////////
// WEBPACK FOOTER
// ./node_modules/nm-react-chat/es/utils/firebase/firebase.js
// module id = 27
// module chunks = 0